class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.dialogHolder = this.querySelector('[role="dialog"]');
    this.querySelectorAll('[id^="ModalClose"]').forEach((close) => {
      close.addEventListener('click', this.hide.bind(this, false));
    });
    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    // bodyScroll.lock(this.dialogHolder);
    this.setAttribute('open', '');
    trapFocus(this, this.dialogHolder);
    window.pauseAllMedia();
  }

  hide() {
    // bodyScroll.unlock(this.dialogHolder);
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    const modal = document.querySelector(this.getAttribute('data-modal'));
    if (modal) {
      this.modal = modal;
      modal.show(this.button);
    }
  }
}
customElements.define('modal-opener', ModalOpener);

(() => {
  if (customElements.get('video-modal-opener')) {
    return;
  }

  class VideoModalOpener extends ModalOpener {
    constructor() {
      super();
    }

    onClick() {
      super.onClick();
      //console.log("--->>>")
      if (!this.modal) return;

      this.modal.querySelector('video')?.play();
    }
  }

  customElements.define('video-modal-opener', VideoModalOpener);
})(); 

// vidio popup

  document.addEventListener('DOMContentLoaded', function () {
    // Add class on open
    document.querySelectorAll('.videos__item-toggle').forEach(function (el) {
      el.addEventListener('click', function () {
        document.body.classList.add('toggle-open');

        // Find and autoplay the video inside the corresponding modal
        const modalId = el.closest('[data-modal]').getAttribute('data-modal');
        const modal = document.querySelector(modalId);

        if (modal) {
          const video = modal.querySelector('video');
          if (video) {
            video.play().catch(() => {
              // Optional: handle autoplay errors (e.g. browser policy)
              // console.warn('Autoplay blocked or failed.');
            });
          }
        }
      });
    });

    // Pause and reset video on close
    document.querySelectorAll('.modal-dialog__close, .modal-dialog__overlay').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        const modalWrapper = event.target.closest('.modal-dialog__wrapper');
        if (!modalWrapper) return;

        const video = modalWrapper.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        document.body.classList.remove('toggle-open');
      });
    });
  });